/* RESPONSIBLE TEAM: team-actions */
import type Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import type Transition from '@ember/routing/transition';
import { hash } from 'rsvp';

export default class ProceduresIndexRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare store: Store;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare router: RouterService;

  get titleToken() {
    if (this.appService.app.canUseProceduresClosedBeta) {
      return this.intl.t('fin-ai-agent.train.procedures.title');
    }
    if (this.appService.app.canUseAiAgentWorkflows) {
      return this.intl.t('standalone.tasks.list.title');
    } else {
      return this.intl.t('fin-ai-agent.train.procedures.title');
    }
  }

  async beforeModel(transition: Transition) {
    // Redirect to tasks if feature flag is off
    if (!this.appService.app.canUseProceduresClosedBeta) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.tasks', {
        queryParams: transition.to?.queryParams || {},
      });
      return;
    }

    await this.reportingMetrics.loadMetricsAndProperties();
  }

  async model() {
    let messengerSettingsLanguages = await this.store.findRecord(
      'messenger-settings/languages',
      this.appService.app.id,
    );

    return hash({
      languages: messengerSettingsLanguages,
    });
  }
}
